module.exports = __webpack_public_path__ + "static/media/27OCHA7.d844de81.jpg";